import {Layout} from "../components/layout";

const layout: Layout = new Layout();
